export default {
    data() {
      return {
        errorMessage: null,
      }
    },
    methods: {
        validate(rules) {
            const isValid = this.$refs.form.validate();
            this.errorMessage = null;
            if(rules) {
                const errors = this.$_validator_nest(rules, this);
                if( errors.length > 0 ) {
                    console.error('validations: ', errors);
                    this.errorMessage = errors[0];
                    return false;
                }
                return true;
            }
            return isValid;
        },
        $_validator_nest(rules, data, prefix = '') {
            return Object.keys(rules).reduce( (result, field) => {
            if(typeof rules[field] === "object") {
                if(Array.isArray(rules[field])) {
                    rules[field].forEach((rule, index) => {
                        const message = rule(data[field]);
                        if(message !== true) {
                            result.push(this.$t(`VALIDATE.${prefix}${field}[${index}]`));
                        }
                    })
                } else {
                    if(Array.isArray(data[field])) {
                        data[field].forEach((d) => {
                            result.push(...this.$_validator_nest(rules[field], d, prefix + field + '.'))
                        })
                    } else {
                        result.push(...this.$_validator_nest(rules[field], data[field], prefix + field + '.'))
                    }
                }
            }
            
            return result;
            }, [] )
        },
    }
  }
  